export default __webpack_public_path__ + "media/zurb/img/legacy/clue/instructions-1-50ad2aca71b8032e897e8a4dbc24beee.jpg";